var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.env)?_c('div',{staticClass:"sticky-top border pt-1 px-4 bg-light small text-dark text-center",staticStyle:{"height":"2rem"}},[_c('strong',[_vm._v(" User Acceptance Testing - v"+_vm._s(_vm.version)+" "+_vm._s(_vm.env)+" ")])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8007ba3e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/navigation/banner-environment.vue
// module id = null
// module chunks = 